import { Box, Breadcrumbs, Container, Link, Typography } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import React from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Header = (props) => {
  const breadcrumbs = [
    <Typography key="1" variant="body2" color={'black'}>
      Home
    </Typography>,
    <Typography key="2" variant="body2" color={'black'}>
      Destinations
    </Typography>,
    <Typography key="3" variant="body2" color={'black'}>
      {props.product.title}
    </Typography>,
  ];

  return (
    <Container
      sx={{
        mt: 4,
      }}>
      <Typography variant="h1" mb={2}>
        {props.product.title}
      </Typography>

      <Box
        sx={{
          mb: 1,
        }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: {
            xs: 'flex-start',
            sm: 'center',
          },
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          gap: {
            xs: 1,
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}>
          <Box>
            <Typography variant="body2">{props.product.city}</Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}>
          <Link
            href="#"
            underline="none"
            color={'inherit'}
            sx={{
              display: 'none',
              alignItems: 'center',
              gap: 0.5,
            }}>
            <IosShareIcon fontSize={'small'} /> <Typography variant="body2">Share</Typography>
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default Header;
